export const ActionTypes = {
    SET_PENDING_LIST: "SET_PENDING_LIST",
    SET_BILLED_BY_LIST: "SET_BILLED_BY_LIST",
    SET_BILLED_TO_LIST: "SET_BILLED_TO_LIST",
    SET_NOT_BILLED_LIST: "SET_NOT_BILLED_LIST",
    SET_UPCOMING_LIST: "SET_UPCOMING_LIST",
    SET_SEARCH_LIST: "SET_SEARCH_LIST",
    SET_DETAILS: "SET_DETAILS",
    UPDATE_MEDICARE_PARTICIPATING: "UPDATE_MEDICARE_PARTICIPATING",
    SET_AP_SBS_REPORT: "SET_AP_SBS_REPORT"
};